var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('draggable',{ref:_vm.name,staticClass:"inner",attrs:{"list":_vm.items,"group":"order","id":_vm.name},on:{"start":function($event){return _vm.startDrag()},"end":function($event){return _vm.endDrag()}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }